import { Box, BoxProps } from "@chakra-ui/react";

type PanelProps = BoxProps & {};

const Panel = (props: PanelProps) => (
  <Box p="3" bg="dark.900" borderRadius="lg" w="full" {...props} />
);

export default Panel;
